export function NotFoundView() {
  return (
    <section>
      <h1>Not found</h1>
    </section>
  );
}
